<ng-container *ngIf="!isLoading">
  <div
    *ngIf="
      (!multiple && displayedFiles?.length + uploadedFiles?.length === 0) ||
      (multiple && displayedFiles.length + uploadedFiles?.length < options.maxFilesLimit)
    "
    (click)="
      fileAttached.click(); this.googleServices.setEvent('UploadFile_project', 'Interactivity')
    "
    (dragleave)="onDragLeave($event)"
    (dragover)="onDragOver($event)"
    (drop)="onDrop($event)"
    [class.dragging]="isDragging"
    class="upload-file-input mb-3 drop-zone"
  >
    <div class="flex flex-col justify-center items-center gap2">
      <mat-icon class="icon-size-7" svgIcon="mat_outline:file_upload"></mat-icon>
      <p class="text-secondary mt-2 text-center mb-0">
        {{ 'Drag and drop ' | transloco
        }}{{ multiple ? ('files' | transloco) : ('file' | transloco)
        }}{{ ' here to attach,' | transloco }}<br />
        {{ 'or click to browse ' | transloco
        }}{{ multiple ? ('files' | transloco) : ('file' | transloco) }}.
      </p>
    </div>
    <input
      type="file"
      class="hidden"
      (change)="onHandleFileInput($event.target.files)"
      (click)="fileAttached.value = null"
      #fileAttached
      [multiple]="multiple"
      [accept]="options?.allowedExtensions"
    />
  </div>
</ng-container>
<div *ngIf="isLoading" class="upload-file-input mb-3">
  <div class="align-items-center d-flex flex-column">
    <p
      class="text-color-onyx-imp font-16-imp font-md-14-imp text-center mb-0 flex flex-row items-center"
    >
      <mat-progress-spinner
        color="primary"
        diameter="40"
        mode="indeterminate"
        class="me-3 -ms-3"
      ></mat-progress-spinner>
      {{ 'Uploading...' | transloco }}
    </p>
  </div>
  <input
    type="file"
    class="hidden"
    (change)="onHandleFileInput($event.target.files)"
    (click)="fileAttached.value = null"
    #fileAttached
    [multiple]="multiple"
    [accept]="options?.allowedExtensions"
  />
</div>

<ng-container *ngIf="displayedFiles?.length">
  <div class="flex flex-col">
    <div class="w-full mb-3" *ngFor="let file of displayedFiles; let i = index">
      <div class="uploaded-file-item flex w-full flex-row items-stretch justify-center">
        <div class="uploaded-icon">
          <mat-icon svgIcon="attachment"></mat-icon>
        </div>
        <div class="d-flex flex-column justify-content-center flex-grow-1 mx-3 text-truncate">
          <p class="file-name d-flex align-items-center">
            <span class="name text-truncate d-inline-block">{{ file?.name }}</span>
          </p>
          <span *ngIf="file?.size" class="file-size">{{ file?.size | fileSize }}</span>
        </div>
        <div class="uploaded-file-actions">
          <button
            *ngIf="!options?.disableDelete"
            class="delete"
            (click)="onDeleteDisplayedFile(file)"
          >
            <span>
              <mat-icon svgIcon="file_download"></mat-icon>
            </span>
          </button>
          <span class="mx-1"></span>
          <button
            *ngIf="!options?.disableDownload"
            class="download"
            (click)="downloadEmitter.emit(file)"
          >
            <span>
              <mat-icon svgIcon="delete"></mat-icon>
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="uploadedFiles?.length">
  <div class="flex flex-wrap">
    <div class="w-full mb-3" *ngFor="let file of uploadedFiles; let i = index">
      <div
        class="uploaded-file-item flex w-full flex-row items-stretch justify-between rounded-md"
        style="word-break: break-word"
      >
        <div class="uploaded-icon w-8">
          <mat-icon color="accent" svgIcon="attachment"></mat-icon>
        </div>
        <div class="flex w-full flex-col justify-start flex-grow-1 mx-3 text-truncate">
          <p class="file-name d-flex align-items-center">
            <span class="name text-truncate d-inline-block">{{ file?.name }}</span>
          </p>
          <span class="file-size text-secondary">{{ file?.size | fileSize }}</span>
        </div>
        <div class="uploaded-file-actions">
          <button class="delete opacity-40 hover:opacity-90" (click)="onDeleteUploadedFile(file)">
            <mat-icon class="" svgIcon="delete"></mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<div class="flex justify-end my-2" *ngIf="uploadAction && uploadedFiles.length !== 0">
  <button
    mat-raised-button
    class="mx-2 mat-dense"
    color="primary"
    [disabled]="isLoading || uploadedFiles.length === 0"
    (click)="onUploadActionClicked()"
  >
    {{ 'upload' | transloco }}
  </button>
</div>

<div class="attachments-error">
  <mat-error class="font-14 text-center mt-2" *ngIf="!allowedUploadedFilesLimit">
    {{ 'Uploaded ' | transloco }}{{ multiple ? ('files' | transloco) : ('file' | transloco)
    }}{{ ' is more than the allowed count' | transloco }}
  </mat-error>
  <mat-error class="font-14 text-center mt-2 self-center" *ngIf="!allowedFileType">
    {{ 'File type is not allowed!' | transloco }}, <br />
    <span class="flex-wrap break-words">
      {{ 'The Allowed extensions are' | transloco }}
      {{ options.allowedExtensions.join(', ') }}
    </span>
  </mat-error>
  <mat-error class="font-14 text-center mt-2" *ngIf="!allowedFileSize">
    {{ 'File size is more than the allowed file size ' | transloco }}{{ options.maxFileSize
    }}{{ 'MB' }}
  </mat-error>
  <mat-error class="font-14" *ngIf="!fileNotDuplicated">
    {{ 'File is duplicated' | transloco }}
  </mat-error>
</div>
